
import type { Client } from "@/types";

export const transformClientData = (
  supabaseClient: any,
  metrics: any,
  programsData: any[]
): Client => {
  // Extract programs from the programsData
  const clientPrograms = programsData.map(program => ({
    id: program.program_id,
    name: program.name || (program.program_data?.name || "Unnamed Program"),
    duration: program.duration || (program.program_data?.duration || "4")
  }));

  console.log("Transformed client programs:", clientPrograms);

  // Create the transformed client object
  const transformedClient: Client = {
    id: supabaseClient.client_id,
    name: supabaseClient.full_name || "",
    avatar: "/placeholder.svg", // Default avatar
    joinDate: supabaseClient.created_at,
    status: "active",
    currentPlan: {
      name: clientPrograms.length > 0 ? clientPrograms[0].name : "No Program",
      progress: {
        current: 0,
        total: 100
      }
    },
    programs: clientPrograms,
    age: supabaseClient.age,
    email: supabaseClient.email || "",
    phone: supabaseClient.phone || "",
    gender: supabaseClient.gender || "",
    goals: supabaseClient.goals || "",
    totalSessions: metrics.totalSessions || 0,
    completedWorkouts: metrics.completedWorkouts || 0,
    progress: {
      completionRate: metrics.completionRates || [],
      performance: metrics.performanceScores || [],
      attendance: metrics.attendanceRate || 0,
      consistency: metrics.consistencyRate || 0
    },
    notes: supabaseClient.notes
      ? [{ date: new Date().toISOString().split("T")[0], content: supabaseClient.notes }]
      : []
  };

  return transformedClient;
};
